export const useDeletingCourseVersion = defineStore(
  'deletingCourseVersion',
  () => {
    const STORAGE_KEY = 'deletingCourseVersionIds'
    const MAX_AGE_MS = 10 * 60 * 1000

    const expiryTimers = new Map<string, ReturnType<typeof setTimeout>>()

    const stored = sessionStorage.getItem(STORAGE_KEY)
    const deletingCourseVersionIds = ref<string[]>(stored ? JSON.parse(stored) : [])

    const persist = () => {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(deletingCourseVersionIds.value))
    }

    const stopDeleting = (id: string) => {
      if (expiryTimers.has(id)) {
        clearTimeout(expiryTimers.get(id))
        expiryTimers.delete(id)
      }
      deletingCourseVersionIds.value = deletingCourseVersionIds.value.filter(
        (existingId) => existingId !== id,
      )
      persist()
    }

    const startDeleting = (id: string) => {
      if (!deletingCourseVersionIds.value.includes(id)) {
        deletingCourseVersionIds.value.push(id)
        persist()
      }

      if (expiryTimers.has(id))
        clearTimeout(expiryTimers.get(id))

      expiryTimers.set(id, setTimeout(() => {
        stopDeleting(id)
      }, MAX_AGE_MS))
    }

    const isDeleting = (id: string) => {
      return deletingCourseVersionIds.value.includes(id)
    }

    const clearAll = () => {
      expiryTimers.forEach((timer) => clearTimeout(timer))
      expiryTimers.clear()
      deletingCourseVersionIds.value = []
      sessionStorage.removeItem(STORAGE_KEY)
    }

    return {
      deletingCourseVersionIds,
      startDeleting,
      stopDeleting,
      isDeleting,
      clearAll,
    }
  },
)
